import React from "react";

const ThumbGeneric = () => (
  <div className="tt">
    <div className="tt-bar brand" />
    <div className="tt-block" />
    <div className="tt-bar faint" />
    <div className="tt-block" />
  </div>
);

const resolvedThemeValue = (field, formValues) => {
  if (!field) return null;
  const key = field.key;
  const v = formValues[key];
  if (typeof v !== "undefined" && v !== null && v !== "") return v;
  return null;
};

const ThemeSection = ({
  section,
  themes = [],
  formValues = {},
  fieldMeta = {},
  updateField,
  requestDelete,
  isSuperAdmin = false,
}) => {
  // Find the question that stores the selected theme (single_select in this section)
  const allQuestions = (section?.subsections || []).flatMap((s) => s.questions || []);
  const themeQuestion = allQuestions.find(
    (q) => q.input_type === "single_select" || /theme/i.test(q.key) || /theme/i.test(q.prompt || "")
  ) || allQuestions[0];

  const selected = resolvedThemeValue(themeQuestion, formValues);

  const handleSelect = (t) => {
    if (themeQuestion) {
      updateField(themeQuestion, t.theme_slug || t.slug || t.id || t.value, true);
    }
  };

  const selectedTheme = themes.find((t) => String(t.theme_slug || t.slug || t.id || "") === String(selected || ""));

  if (!themes.length) {
    return (
      <div className="gob-empty-state">
        <p>No themes available yet.</p>
      </div>
    );
  }

  const hasSelection = !!selected;

  return (
    <div>
      <div className="gob-breadcrumb">
        <span>Publisher Channel</span>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 12, height: 12 }}>
          <polyline points="9 18 15 12 9 6" />
        </svg>
        <span className="current">Theme</span>
      </div>

      <div className="gob-page-head">
        <h1 className="gob-page-title">Choose a <span className="gradient">Theme</span></h1>
        <p className="gob-page-sub">
          Pick a layout from {themes.length} templates. Brand Studio assets fill the slots automatically.
        </p>
      </div>

      {hasSelection && selectedTheme && themeQuestion && (
        <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 13, color: "var(--gob-ink-2)" }}>
            Currently selected: <strong>{selectedTheme.display_name || selectedTheme.name || selected}</strong>
          </span>
          {requestDelete && !isSuperAdmin && (
            <button
              type="button"
              className="gob-btn"
              onClick={() => requestDelete(themeQuestion.key)}
              style={{ fontSize: 11, padding: "4px 10px" }}
            >
              Clear selection
            </button>
          )}
        </div>
      )}

      <div className="theme-grid">
        {themes.map((t) => {
          const themeValue = t.theme_slug || t.slug || t.id || t.value;
          const themeName  = t.display_name || t.name || themeValue;
          const isSelected = String(selected || "") === String(themeValue || "");
          const themeImage = t.thumbnail_url || t.image_url || t.image || t.preview_image_url;

          return (
            <div
              key={themeValue}
              id={themeQuestion ? `q-row-${themeQuestion.key}` : undefined}
              data-key={themeQuestion ? themeQuestion.key : undefined}
              className={`theme-card${isSelected ? " selected" : ""}`}
              onClick={() => !isSuperAdmin && handleSelect(t)}
              style={isSuperAdmin ? { cursor: "default" } : undefined}
            >
              <div className="theme-thumb">
                {themeImage
                  ? <img src={themeImage} alt={themeName} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 6 }} />
                  : <ThumbGeneric />
                }
              </div>
              <div className="theme-info">
                <div className="theme-name">
                  {themeName}
                  {t.tag && <span className={`theme-tag ${t.tag}`}>{t.tag}</span>}
                </div>
                {t.description && <div className="theme-desc">{t.description}</div>}
                <div className="theme-meta">
                  {t.best_for && <span className="theme-best-for">{t.best_for}</span>}
                  <div className="theme-actions">
                    {t.preview_url && (
                      <a
                        className="theme-preview-btn"
                        href={t.preview_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                        Preview
                      </a>
                    )}
                    {!isSuperAdmin ? (
                      <button
                        className="theme-preview-btn"
                        style={isSelected ? { background: "var(--gob-primary)", color: "white", borderColor: "var(--gob-primary)" } : {}}
                        onClick={(e) => { e.stopPropagation(); handleSelect(t); }}
                      >
                        {isSelected ? "✓ Selected" : "Select"}
                      </button>
                    ) : isSelected ? (
                      <span style={{ fontSize: 12, color: "var(--gob-success)", fontWeight: 600 }}>✓ Selected</span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThemeSection;
